import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Revel } from '../models/revel';

@Injectable({
  providedIn: 'root'
})
export class RevelService {
  private apiUrl = environment.apiBaseUrl + 'revels'; // Use environment.apiBaseUrl

  constructor(private http: HttpClient) {}

  getRevels(): Observable<Revel[]> {
    return this.http.get<Revel[]>(this.apiUrl);
  }

  getRevelById(id: number): Observable<Revel> {
    return this.http.get<Revel>(`${this.apiUrl}/${id}`);
  }

  createRevel(revel: Revel): Observable<Revel> {
    return this.http.post<Revel>(this.apiUrl, revel);
  }

  updateRevel(id: number, revel: Revel): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${revel.id}`, revel);
  }

  deleteRevel(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
